const REFERRAL_STORAGE_KEY = 'referral_ref';
const REFERRAL_TTL_MS = 90 * 24 * 60 * 60 * 1000;

export function captureReferralFromUrl() {
  if (typeof window === 'undefined') {
    return;
  }

  const ref = Number(new URLSearchParams(window.location.search).get('ref'));
  if (!ref) {
    return;
  }

  try {
    window.localStorage.setItem(
      REFERRAL_STORAGE_KEY,
      JSON.stringify({ ref, savedAt: Date.now() })
    );
  } catch {
    // private mode / quota — регистрация просто пойдёт без ref
  }
}

export function getStoredReferral() {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(REFERRAL_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    const ref = Number(parsed?.ref);
    const savedAt = Number(parsed?.savedAt);
    const isExpired = !savedAt || Date.now() - savedAt > REFERRAL_TTL_MS;

    if (!ref || isExpired) {
      window.localStorage.removeItem(REFERRAL_STORAGE_KEY);
      return null;
    }

    return ref;
  } catch {
    return null;
  }
}

export function clearStoredReferral() {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.removeItem(REFERRAL_STORAGE_KEY);
  } catch {
    // ignore
  }
}
